import { getBanks } from './banks';
import { IApplicationState } from '../../types/redux';

export const getHasBanks = (state: IApplicationState): boolean => {
  const banks = getBanks(state);

  return banks?.length > 0;
};
